module.exports = "<h2>{{pageTitle}}</h2>\n<div>\n       this is Home Page\n</div>\n\n"